import React from 'react';
import { connect } from 'react-redux';
import { movil } from '../../app-movil';
import { authentication } from '../../app-database';
import { conectarFirebase } from '../../app-persistance';

import Invitados from '../../acceso-familiar/invitados.cmpt';
import InvitadosMovil from '../../acceso-familiar/invitados-movil.cmpt';
import ModalInvitar from '../../acceso-familiar/modalInvitar.cmpt';
import ModalInvitarMovil from '../../acceso-familiar/modalInvitarMovil.cmpt';
import ModalGestionar from '../../acceso-familiar/modalGestionar.cmpt';
import ModalGestionarMovil from "../../acceso-familiar/modalGestionarMovil.cmpt";

const mapState = (state) => {
  return {
    listaFamiliares: state.af.listaFamiliares,
    listaPolizas: state.af.listaPolizas,
    dispositivo: state.global.dispositivo
  };
}

const mapDispatch = (dispatch) => {
  return {
    enviarLogin: (oMensaje) => {
      dispatch({ "type": "ENVIAR_MENSAJE_MOVIL", "mensaje": oMensaje});
    }
  }
}

class Datos extends React.Component {

  state = {
    isModalOpened: false
  }

  componentDidMount = () => {
    authentication.onAuthStateChanged(function(user) {
      if (user) {
        let redux = angular.element(document.querySelector('ui-view')).scope().$parent.state.redux;
        redux.dispatch({ "type": "CVE_CLIENTE_UNICO", "uid": authentication.currentUser.uid });
        conectarFirebase(redux);
      }
    });
  }

  componentWillMount = () => {
    /*if(this.props.listaFamiliares.length == 0) {
      //this.props.cargarFamiliares();
    }
    if(this.props.listaPolizas.length == 0) {
      this.props.cargarPolizas();
    }*/
  }

  pasoAnterior = () => {
    let mensaje = {"return": "home"};
    movil("accesoFamiliar", mensaje);
  }
  
  render() {
    return <div className="container">
      <div className="box-wrap">
        <div className="header-content clearfix">
          <div className="pull-left">
            {/*<h4>Acceso Familiar</h4>
              <h6><small>Invitados</small></h6>*/}
          </div>
        </div>
        {this.props.dispositivo === "web" ? <Invitados /> : <InvitadosMovil />}
      </div>
      {this.props.dispositivo === "web" ?
        <div
          className="modal fade modal-msj"
          id="modal-invitar"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="modal-invitarLabel"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <ModalInvitar />
            </div>
          </div>
        </div>
      :
        <div>
          {this.state.isModalOpened ?
            <ModalInvitarMovil />
          : null}
        </div>
      }
      {this.props.dispositivo === "web" ?
        <div
          className="modal fade modal-msj"
          id="modal-gestionar"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="modal-gestionarLabel"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <ModalGestionar />
            </div>
          </div>
        </div>
      : <ModalGestionarMovil /> }
    </div>
  }
}

export default connect(mapState, mapDispatch)(Datos);



// WEBPACK FOOTER //
// ./src/movil/acceso-familiar/flujo.cmpt.js